import callApi from '.';

export const getServiceComplaints = () => {
    return callApi(`/api/complaints/customerComplaints`);
};
